import React from "react";
import { matchPath } from "react-router-dom";

export interface GeneratedPageProps {
  data?: any;
}

export interface GeneratedPageRoute {
  pageId: string;
  routePath: string;
  Component: React.LazyExoticComponent<React.ComponentType<GeneratedPageProps>>;
}

export const generatedPageRegistry: GeneratedPageRoute[] = [
  {
    pageId: "tendency",
    routePath: "/",
    Component: React.lazy(() => import("./tendency")),
  },
];

export const normalizeRoutePath = (routePath: string) => {
  if (!routePath || routePath === "/") {
    return "/";
  }
  const normalized = routePath.replace(/\/+/g, "/").replace(/\/$/, "");
  return normalized.startsWith("/") ? normalized : `/${normalized}`;
};

export const resolveGeneratedPage = (pathname: string) => {
  const normalizedPath = normalizeRoutePath(pathname);
  return generatedPageRegistry.find(route =>
    Boolean(matchPath({ path: normalizeRoutePath(route.routePath), end: false }, normalizedPath)),
  );
};
